export const string = (property) => {
  let sortOrder = 1;

  if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
  }

  const nested = property.split(".");
  return (x, y) => {
    for (const accessor of nested) {
      x = x[accessor];
      y = y[accessor];
    }

    if (sortOrder === -1) {
      return y.localeCompare(x);
    } else {
      return x.localeCompare(y);
    }
  };
};

export const number = (property) => {
  let sortOrder = 1;

  if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
  }

  const nested = property.split(".");
  return (x, y) => {
    for (const accessor of nested) {
      x = x[accessor];
      y = y[accessor];
    }

    if (sortOrder === -1) {
      return y - x;
    } else {
      return x - y;
    }        
  };
};

export const objValueAsc = (mapping) => {
  return Object.entries(mapping)
    .sort(([, a], [, b]) => a - b)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
};

export const objValueDsc = (mapping) => {
  return Object.entries(mapping)
    .sort(([, a], [, b]) => b - a)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
};
